/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";

import Footer from "./footer";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
  fontSize: "14px",
};

const Th = ({ children, style, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};
const Td = ({ children, style, row, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style, fontWeight: row.bold ? "bold" : 400 }}>
      {children}
    </th>
  );
};

const dataTable = [
  {
    bold: false,
    id: {
      value: 1,
      bg: false,
    },
    spendingId: {
      value: "[09]",
      bg: false,
    },
    money: {
      value: 0,
      bg: false,
    },
    title: {
      value: "Doanh thu tính thuế",
      bg: false,
    },
  },
  {
    bold: false,
    id: {
      value: 2,
      bg: false,
    },
    spendingId: {
      value: "[10]",
      bg: false,
    },
    money: {
      value: "0.00",
      bg: false,
    },
    title: {
      value: "Tỷ lệ (%) thuế TNDN",
      bg: false,
    },
  },
  {
    bold: false,
    id: {
      value: 3,
      bg: false,
    },
    spendingId: {
      value: "[11]",
      bg: false,
    },
    money: {
      value: 0,
      bg: false,
    },
    title: {
      value: "Số thuế TNDN được miễn, giảm theo Hiệp định",
      bg: false,
    },
  },
  {
    bold: false,
    id: {
      value: 4,
      bg: false,
    },
    spendingId: {
      value: "[12]",
      bg: false,
    },
    money: {
      value: 0,
      bg: false,
    },
    title: {
      value: "Số thuế TNDN phải nộp",
      bg: false,
    },
  },
  {
    bold: false,
    id: {
      value: 5,
      bg: false,
    },
    spendingId: {
      value: "[13]",
      bg: false,
    },
    money: {
      value: 0,
      bg: false,
    },
    title: {
      value: "Số thuế TNDN nộp thừa kỳ trước chuyển sang kỳ này",
      bg: false,
    },
  },
  {
    bold: false,
    id: {
      value: 6,
      bg: false,
    },
    spendingId: {
      value: "[14]",
      bg: false,
    },
    money: {
      value: 0,
      bg: false,
    },
    title: {
      value: "Số thuế TNDN đã nộp tạm trong năm",
      bg: false,
    },
  },
  {
    bold: false,
    id: {
      value: 7,
      bg: true,
    },
    spendingId: {
      value: "[15]",
      bg: true,
    },
    money: {
      value: 0,
      bg: true,
    },
    title: {
      value: "Chênh lệch giữa số thuế phải nộp và số thuế đã nộp tạm trong năm [15]=[12]-[14]",
      bg: true,
    },
  },
  {
    bold: false,
    id: {
      value: 8,
      bg: true,
    },
    spendingId: {
      value: "[16]",
      bg: true,
    },
    money: {
      value: 0,
      bg: true,
    },
    title: {
      value: "Số thuế TNDN còn phải nộp [16]=[12]-[13]-[14]",
      bg: true,
    },
  },
];

export default function TaxPersonalTable({ formData, setFieldValue }) {
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value } = values;

    setData((prev) =>
      prev.map((item) => {
        if (item.id.value === id) {
          return { ...item, [name]: { ...item[name], value } };
        }
        return item;
      })
    );
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box display="flex" justifyContent="flex-end">
        <Typography variant="subtitle1" fontSize={14} fontStyle="italic">
          Đơn vị tiền: Đồng Việt Nam
        </Typography>
      </Box>
      <Box>
      <Box style={{ maxWidth: "100%", overflowX: "auto" }}>
        <table style={tableStyle}>
          <thead style={{ background: "#eaeae9" }}>
            <tr>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>
                STT
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>
                Chỉ tiêu
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>Mã chỉ tiêu</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>Số tiền</Th>
            </tr>
            <tr>
              <Th style={{ textAlign: "center"}}>
                (1)
              </Th>
              <Th style={{ textAlign: "center"}}>
                (2)
              </Th>
              <Th style={{ textAlign: "center"}}>(3)</Th>
              <Th style={{ textAlign: "center"}}>(4)</Th>
            </tr>
          </thead>
          <tbody>
            {data &&
              data.length > 0 &&
              data.map((row, index) => (
                <tr key={row.id.value}>
                  <Td
                    row={row}
                    style={{
                      textAlign: "center",
                      background: !row.id.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.id.value}
                  </Td>
                  <Td
                    row={row}
                    style={{
                      textAlign: "left",
                      background: !row.title.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.title.value}
                  </Td>
                  <Td
                    row={row}
                    style={{
                      textAlign: "center",
                      background: !row.spendingId.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.spendingId.value}
                  </Td>
                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.money.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.money.bg ? (
                      row.money.value
                    ) : (
                      <InputTable
                        id={row.id.value}
                        name="money"
                        value={row.money.value}
                        onChange={handleChange}
                        type= {row.id.value == 2 ? "decimal" : "number"}
                      />
                    )}
                  </Td>
                </tr>
              ))}
          </tbody>
        </table>
        </Box>
        <Footer formData={formData} />
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { id, onChange, type, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;
  const regexDecimal = /^(0|0?\.\d*|1|1(\.0*)?)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value;
    if (type == "number") {
      if (!regexNumber.test(newValue)) return;
      onChange({ id, value: newValue !== "" ? +newValue : "", name });
    } else if (type == "decimal") {
      if (!regexDecimal.test(newValue)) return;
      onChange({ id, value: newValue, name });
    } else {
      onChange({ id, value: newValue !== "" ? newValue : "", name });
    }
  }
  return (
    <input
      type={type == "date" ? "date" : ""}
      style={{
        textAlign: type == "number" || type == "decimal" ? "right" : "left",
        fontSize: 14,
        color: "#344767",
        border: "none",
        width: type == "date" ? "150px" : "100px",
        background: "transparent",
        padding: "4px 4px 4px 4px",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}